import ApiService from "@/core/services/api.service";
// import { deepCopy } from "@/util/index.js";
// let Base64 = require('js-base64').Base64;
// action types
export const ADDTABLE = "addTable";
export const ADDFORM = "addForm";
export const DELETEtABLE = "deleteTable";
//mutations types
export const SETTABLE = "setTable";


const state = {
    tablesData: []
};


const actions = {
    // [CHANGE_MENUS]({ commit }) {
    //   commit(SET_CHANGE_MENUS, MENU);
    //   return MENU;
    // },
    [DELETEtABLE]({ commit }, id) {
        console.log(commit)
        return ApiService.delete(`/api-uaa/clients/${id}`);
    },
    [ADDFORM]({ commit }, o) {
        console.log(commit)
        return ApiService.post(`/api-uaa/clients/saveOrUpdate`, o, { type: 'json' })
    },
    [ADDTABLE]({ commit }, { clientId, page, limit }) {
        console.log(commit)
        return ApiService.get(`/api-uaa/clients/list?clientId=${clientId}&page=${page}&limit=${limit}`)
    },

};
const mutations = {
    [SETTABLE](state, data) {
        state.tablesData = data;
    },

};

export default {
    namespaced: true,
    state,
    actions,
    mutations,
};
